import styled from 'styled-components';

const FilterRow = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { FilterRow, ButtonContainer };
